import Modal from './Modal'
export default Modal

export {ModalProvider} from './ModalProvider' 